export const colors = {
  light: ["#E6E7E8", "#BBBDBF"],
  dark: ["#404041", "#6D6E70"],
  colors: {
    red: "#ED1C24",
    orange: "#EAA9FF",
    green: "#006BFD"
  }
};

export const configs = {
  padding: 20,
  mapHeightPercent: 0.60,

  // mapStyle: "mapbox://styles/mapbox/dark-v9",
  // mapStyle: "mapbox://styles/violaber/cjilfp7w624jp2sp7bl36vyqw",
  mapStyle: "mapbox://styles/violaber/cjin63xo10wuu2rod9qeg0lvs",

  pointA: {
    coordinates: [48.744508, 11.436795],
    label: "HBF",
    icon: "icons/a.svg",
    marker: "a"
  },
  pointB: {
    coordinates: [48.782972, 11.414087],
    label: "AUDI",
    icon: "icons/b.svg",
    marker: "b"
  },

  sliderColors: [
    colors.colors.red,
    colors.colors.orange,
    colors.colors.green,
  ],

  sliderHeight: 50,
  sliderRailColor: "white",
  sliderBarHeight: 4,
  sliderPadding: 4,
  sliderMax: 1000,
  sliderMin: 0,
  sliderSteps: 200,

  idleTime: 7000,

  breakPoints: {
    narrow: 760,
  },

  supportedVersions: {
    safari: "11.0.0",
    firefox: "59.0.0",
    chrome: "64.0.0",
    edge: "16.0.0",
    ios: "10.0.0",
    "ios-webview": "11.0.0"
  }
};



export const themes = {
  dark: {
    appBackground: colors.dark[0],
    iconBackground: colors.light[1],
    iconTitleColor: colors.light[1],
    menuBackground: colors.dark[1],
    textPopupBackground: colors.dark[1],
    sliderTrackColor: colors.dark[1],
    sliderMarksColor: "#b2b2b3",
  },
  light: {
    appBackground: colors.light[0],
    iconBackground: colors.light[1],
    iconTitleColor: colors.dark[1],
    menuBackground: colors.light[1],
    textPopupBackground: colors.light[1],
    sliderTrackColor: "white",
    sliderMarksColor: colors.light[0]
  }
};



// WEBPACK FOOTER //
// ./src/configs.js